import { PnEvents } from '../';
export default class RealTimeActions {
    constructor(activeComponents, $log, pn, $timeout) {
        this.activeComponents = activeComponents;
        this.$log = $log;
        this.pn = pn;
        this.$timeout = $timeout;
        this.componentNames = [
            'payment',
            'chat',
            'screenshare',
            'fileTransfer',
            'teleconsent',
            'photoCapture',
        ];
    }
    onLeave(person) {
        this.onLeaveComponentNames.forEach((componentName) => {
            const component = this.activeComponents.getComponent(componentName);
            if (component) {
                component.onLeave(person);
            }
        });
    }
    onPnUnsubscribe() {
        this.componentNames.forEach((componentName) => {
            const component = this.activeComponents.getComponent(componentName);
            if (component && component.onPnUnsubscribe) {
                component.onPnUnsubscribe();
            }
        });
    }
    start() {
        this.pn.addListeners({
            [PnEvents.Message]: this.onMessage.bind(this),
            [PnEvents.Join]: this.onJoin.bind(this),
            [PnEvents.Leave]: this.onLeave.bind(this),
            [PnEvents.Unsubscribe]: this.onPnUnsubscribe.bind(this),
        });
    }
    sendToTarget(target, message) {
        this.pn.send(target.uuid, message);
    }
    sendTargetToAnotherRoom(target, url, transferKey) {
        this.sendToTarget(target, {
            componentName: 'global',
            action: 'initTransferToAnotherRoom',
            content: {
                transferRoomUrl: url,
                transferNotifyKey: transferKey,
                pid: target.state.pid,
            },
        });
        this.pn.forceRemove(target);
    }
    onJoin(person) {
        const chat = this.activeComponents.getComponent('chat');
        if (!chat.isOpen()) {
            chat.openChat(person, false);
        }
    }
    onExtension(pnMessage, person) {
        let component = this.activeComponents.getComponent(pnMessage.componentName);
        if (component) {
            this.beforeExtensionShow(component);
            component.onMessage(pnMessage, person);
        }
        else {
            // This should work for now, although doesn't look reliable
            const extension = pnMessage.componentName.replace(/([A-Z])/g, ($1) => '-' + $1.toLowerCase());
            const componentPath = this.extensionsPathMap[pnMessage.componentName] ||
                `./${extension}/${extension}.js`;
            import(
            /* webpackPrefetch: true */
            /* webpackInclude:  /components\/[a-z-_]+\/[a-z-_]+\.js$/ */
            `${componentPath}`)
                .then((module) => {
                component = this.activeComponents.createComponent(module);
                this.beforeExtensionShow(component);
                component.onMessage(pnMessage, person);
            })
                .catch((err) => {
                console.error(`RealtimeActions: can't load "${extension}" realtime component`, { componentName: pnMessage.componentName }, err);
            });
        }
    }
    beforeExtensionShow(component) {
        // chat and teleconsent should not have impact on others extensions
        if (['chat', 'teleconsent', 'phone', 'fileTransfer', 'photoCapture'].includes(component.componentName))
            return;
        const extensionChanged = this.activeExtension && this.activeExtension !== component;
        if (extensionChanged) {
            this.activeExtension.reset();
        }
        this.activeExtension = component;
    }
}
